import angular from 'angular';

class MetricsCtrl {
  /*@ngInject*/
  constructor($uibModal, MetricsSvc) {
    this.$uibModal = $uibModal;
    this.MetricsSvc = MetricsSvc;
  }

  $onInit() {
    var vm = this;

    vm.metrics = {};
    vm.updatingMetrics = true;
    vm.servicesStats = {};
    vm.cachesStats = {};
    vm.sqlStats = [];

    vm.refresh();
  }

  refresh() {
    let vm = this;
    vm.updatingMetrics = true;
    vm.MetricsSvc.getMetrics(vm.application).then(
      function(promise) {
        vm.metrics = promise;
        vm.processMetrics();
        vm.updatingMetrics = false;
      },
      function(promise) {
        vm.metrics = promise.data;
        vm.processMetrics();
        vm.updatingMetrics = false;
      }
    );
  }

  processMetrics() {
    let vm = this;
    vm.servicesStats = {};
    vm.cachesStats = {};
    vm.sqlStats = [];
    angular.forEach(vm.metrics.timers, function(value, key) {
      if (key.indexOf('fr.cegedim.kiss.') === 0 || key.indexOf('fr.cegedim.epdf.') === 0) {
        var shortKey = key.substring(16);
        vm.servicesStats[shortKey] = value;
      }
      if (key.indexOf('fr.cegedim.zedoc.') === 0) {
        shortKey = key.substring(17);
        vm.servicesStats[shortKey] = value;
      } else if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
        // remove gets or puts
        var index = key.lastIndexOf('.');
        var newKey = key.substr(0, index);

        // Keep the name of the domain
        index = newKey.lastIndexOf('.');
        vm.cachesStats[newKey] = {
          name: newKey.substr(index + 1),
          value: value
        };
      }
    });
    angular.forEach(vm.metrics.histograms, function(value, key) {
      if (key.indexOf('SQL_') === 0) {
        var shortKey = key.substring(4);
        vm.sqlStats.push({ sql: shortKey, stat: value });
      }
    });
    angular.forEach(vm.metrics.gauges, function(value, key) {
      if (key.indexOf('cache.fr.cegedim') !== -1) {
        var index = key.lastIndexOf('.');
        var newKey = key.substr(0, index);

        // Keep the name of the domain
        index = newKey.lastIndexOf('.');
        vm.cachesStats[newKey] = {
          name: newKey.substr(index + 1),
          value: value
        };
      }
    });
  }

  getLabelClass(threadState) {
    if (threadState === 'RUNNABLE') {
      return 'label-success';
    } else if (threadState === 'WAITING') {
      return 'label-info';
    } else if (threadState === 'TIMED_WAITING') {
      return 'label-warning';
    } else if (threadState === 'BLOCKED') {
      return 'label-danger';
    }
  }

  refreshThreadDumpData() {
    let vm = this;
    this.MetricsSvc.threadDump(this.application).then(function(data) {
      vm.$uibModal
        .open({
          component: 'metrics-dump',
          size: 'lg',
          resolve: {
            threadDump: function() {
              return data;
            }
          }
        })
        .result.then(function() {}, function() {});
    });
  }
}

angular.module('app.admin.metrics').component('metrics', {
  templateUrl: require('./metrics.html'),
  controller: MetricsCtrl,
  bindings: {
    application: '<'
  }
});
